module.exports = __webpack_public_path__ + "img/jieguo.558d9721.png";